export const protectedImageProps = {
    draggable: false,
    onContextMenu: (event) => event.preventDefault(),
    onDragStart: (event) => event.preventDefault(),
    style: {
        WebkitUserDrag: 'none',
        WebkitTouchCallout: 'none',
        userSelect: 'none',
    },
};

export const mergeProtectedImageStyle = (style) => ({
    ...protectedImageProps.style,
    ...style,
});
